import React, { useId } from 'react';
import type { ElementType } from 'react';
import clsx from 'clsx';

interface NameWithEmailTooltipProps {
  name?: string | null;
  email?: string | null;
  className?: string;
  as?: ElementType;
}

const NameWithEmailTooltip: React.FC<NameWithEmailTooltipProps> = ({
  name,
  email,
  className,
  as: Component = 'span'
}) => {
  const tooltip = email?.trim() || '';
  const displayName = name?.trim() || tooltip || '-';
  const hasTooltip = tooltip.length > 0;
  const tooltipId = useId();

  return (
    <Component
      className={clsx(className)}
      data-email={hasTooltip ? tooltip : undefined}
      aria-describedby={hasTooltip ? tooltipId : undefined}
    >
      <span
        className={clsx(
          'inline-flex items-center',
          hasTooltip && 'relative group cursor-help'
        )}
      >
        <span>{displayName}</span>
        {hasTooltip && (
          <span
            role="tooltip"
            id={tooltipId}
            className="pointer-events-none absolute left-1/2 top-full z-[60] w-max -translate-x-1/2 translate-y-1 rounded-md bg-gray-900 px-3 py-2 text-sm text-white opacity-0 shadow-xl transition-opacity duration-200 group-hover:opacity-100 group-focus-within:opacity-100"
          >
            {tooltip}
            {/* Arrow pointing up */}
            <span className="absolute bottom-full left-1/2 -translate-x-1/2 border-4 border-transparent border-b-gray-900"></span>
          </span>
        )}
      </span>
    </Component>
  );
};

export default NameWithEmailTooltip;
